import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  ROUTE_404,
  ROUTE_APP_CRAFTER_CHOOSE_PASSWORD,
  ROUTE_APP_CRAFTER_CONFIRM,
  ROUTE_APP_CRAFTER_EMAIL_SENT,
  ROUTE_APP_CRAFTER_RENEW_PASSWORD,
} from '@/common/constants';
import lazyWithCatch from '@/common/helpers/lazyWithCatch';
import PrivateRoute from '@/common/router/PrivateRoute';

const Confirm = lazyWithCatch(() => import('./Confirm/Confirm'));
const RenewPassword = lazyWithCatch(() =>
  import('./RenewPassword/RenewPassword'),
);
const ChoosePassword = lazyWithCatch(() =>
  import('./ChoosePassword/ChoosePassword'),
);
const EmailSent = lazyWithCatch(() => import('./EmailSent/EmailSent'));

const AppCrafterRouter = () => (
  <Switch>
    <Route path={ROUTE_APP_CRAFTER_RENEW_PASSWORD} exact>
      <RenewPassword />
    </Route>
    <Route path={ROUTE_APP_CRAFTER_CHOOSE_PASSWORD} exact>
      <ChoosePassword />
    </Route>
    <Route path={ROUTE_APP_CRAFTER_CONFIRM} exact>
      <Confirm />
    </Route>
    <Route path={ROUTE_APP_CRAFTER_EMAIL_SENT} exact>
      <EmailSent />
    </Route>
    <PrivateRoute>
      <Redirect to={ROUTE_404} />
    </PrivateRoute>
  </Switch>
);

export default AppCrafterRouter;
